/*
 * Fovory sheets.
 * - Menu sheet (snippets/fovory-menu.liquid): opened by "Shop" in the tab bar
 *   (and Minimog's hamburger, if it ever shows).
 * - Country sheet (snippets/fovory-shipto.liquid): opened by "Change" in the footer.
 * Both close with the X, the scrim, Esc or a downward swipe from the top of the sheet.
 * The sheet takes focus when it opens, focus stays inside, and it returns to the
 * button that opened it. Choosing the language or country that is already active
 * only closes the sheet instead of reloading the page.
 * - Account tab: opens Shopify's own sign-in sheet (<shopify-account>, styled in
 *   assets/fovory-account.css) instead of leaving for the account page.
 */
(() => {
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function sheet(root, openSelector, onOpen) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';

    const panel = root.querySelector('.fv-ms');
    const openers = () => document.querySelectorAll(openSelector);
    let lastTrigger = null;
    let hideTimer = null;

    function open(trigger) {
      clearTimeout(hideTimer);
      lastTrigger = trigger || document.activeElement;
      root.hidden = false;
      document.documentElement.classList.add('fv-so-open');
      openers().forEach((b) => b.setAttribute('aria-expanded', 'true'));
      requestAnimationFrame(() =>
        requestAnimationFrame(() => {
          root.classList.add('is-open');
          if (onOpen) onOpen(panel);
          panel.focus({ preventScroll: true });
        })
      );
    }

    function close() {
      if (root.hidden) return;
      root.classList.remove('is-open');
      document.documentElement.classList.remove('fv-so-open');
      openers().forEach((b) => b.setAttribute('aria-expanded', 'false'));
      hideTimer = setTimeout(() => {
        root.hidden = true;
        panel.scrollTop = 0;
      }, reduceMotion() ? 0 : 320);
      if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus({ preventScroll: true });
    }

    document.addEventListener(
      'click',
      (e) => {
        const t = e.target.closest(openSelector);
        if (!t) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        open(t);
      },
      true
    );

    root.addEventListener('click', (e) => {
      if (e.target.closest('[data-fv-ms-close]')) {
        close();
        return;
      }
      const current = e.target.closest('button[type="submit"][aria-current="true"]');
      if (current) {
        e.preventDefault();
        close();
      }
    });

    root.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
        return;
      }
      if (e.key !== 'Tab') return;
      const items = [...panel.querySelectorAll('a[href], button')].filter((el) => el.offsetParent !== null);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    // Swipe the sheet down from its top to close it.
    let startY = null;
    panel.addEventListener('touchstart', (e) => {
      startY = panel.scrollTop <= 0 ? e.touches[0].clientY : null;
    }, { passive: true });
    panel.addEventListener('touchend', (e) => {
      if (startY === null) return;
      if (e.changedTouches[0].clientY - startY > 80) close();
      startY = null;
    }, { passive: true });
  }

  sheet(document.querySelector('[data-fv-ms]'), '[data-fv-ms-open], .m-header__mobile .m-menu-button');

  // Country sheet: the current country is listed first, so it opens at the top.
  sheet(document.querySelector('[data-fv-cs]'), '[data-fv-cs-open]');

  // Account tab (tab bar, below 1024px): open Shopify's sign-in sheet here instead of leaving
  // for the account page. The sheet lives in a copy of <shopify-account> kept off screen and
  // hidden; it is shown only while its dialog is open. If it is not ready, the link works as usual.
  (() => {
    document.addEventListener('click', (e) => {
      const tab = e.target.closest('[data-fv-acc-open]');
      if (!tab || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const host = document.querySelector('shopify-account.fv-tabacc');
      const btn = host && host.shadowRoot && host.shadowRoot.querySelector('.account-button');
      if (!btn) return;
      e.preventDefault();
      host.classList.add('is-on');
      btn.click();
      let tries = 0;
      const check = () => {
        const d = host.shadowRoot.querySelector('dialog');
        if (d && d.open) {
          d.addEventListener('close', () => {
            host.classList.remove('is-on');
            tab.focus({ preventScroll: true });
          }, { once: true });
          return;
        }
        if (++tries < 20) { setTimeout(check, 50); return; }
        host.classList.remove('is-on');
        window.location.href = tab.href;
      };
      check();
    });
  })();
})();
